import type { MessageItem } from "@openim/wasm-client-sdk";
import { FC } from "react";
import { Image, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { getResourceUrl } from "@/utils/common";

interface RefundNotificationProps {
  message: MessageItem;
}

const BannerNotificationRenderer: FC<RefundNotificationProps> = ({ message }) => {
  const res = JSON.parse(message.notificationElem!.detail).bannerElem;

  let { description, external_url, image_url, title, article_id } = res;

  // 检测是否为Electron环境
  const isElectron = Boolean(window.electronAPI);

  const handleClick = () => {
    // 优先处理external_url
    if (external_url) {
      if (isElectron) {
        // 使用专门的API打开外部URL
        window.electronAPI?.openExternalUrl(external_url);
      } else {
        window.open(external_url, "_blank");
      }
      return;
    }

    // 如果没有external_url，则处理article_id的逻辑
    const articleUrl = article_id ? `/article?id=${article_id}` : "/article";

    if (isElectron) {
      // Electron环境 - 打开新窗口展示详情
      window.electronAPI?.openNewWindow({
        url: `/#${articleUrl}`,
        width: 1600,
        height: 1000,
      });
    } else {
      // 浏览器环境 - 打开新标签页
      const baseUrl = window.location.origin;
      const fullUrl = `${baseUrl}#${articleUrl}`;
      window.open(fullUrl, "_blank");
    }
  };

  return (
    <div className="w-[300px] cursor-pointer shadow-sm" onClick={handleClick}>
      <div className="overflow-hidden rounded-t">
        <Image
          className="aspect-[2/1] size-full overflow-hidden rounded-md object-cover"
          src={getResourceUrl(image_url)}
          preview={false}
          placeholder={
            <div className="flex items-center justify-center">
              <Spin />
            </div>
          }
        />
      </div>
      <div className="overflow-hidden rounded-b bg-gray-100 p-2">
        <div className="line-clamp-1">{title}</div>
        <div className="mt-2 line-clamp-2 text-gray-600">{description}</div>
      </div>
    </div>
  );
};

export default BannerNotificationRenderer;
